<template>
    <div name="dropdown" class="relative cursor-pointer h-10 rounded p-2 px-4 bg-white filter-bar-button mt-0 text-center" v-bind:class="modeType()">
        <li @click="toggleMenu()" class="dropdown-toggle " v-bind:class="css" v-if="selectedOption.name !== undefined">
         <template v-if="hasTitle">
          <span class="text-gray-500">{{ title }}</span> <span class="font-semibold text-black ml-2">{{ selectedOption.name }}</span>
         </template>
         <template v-else >
            {{ selectedOption.name }}
          </template>
        </li>

        <li @click="toggleMenu()" class="dropdown-toggle w-full" v-if="selectedOption.name === undefined">
          <template v-if="hasTitle">
            <span class="text-gray-500">{{ title }}</span> <span class="font-semibold text-black ml-2">{{}}</span>
        </template>
         <template v-else >
            {{ placeholderText }}
          </template>
        </li>

        <ul class="dropdown-menu" v-if="showMenu && disabled != true">
            <li v-for="(option, index) in options" :key="index">
                <a href="javascript:void(0)" @click="updateOption(option)">
                    {{ option.name }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: "dropdown",
  data() {
    return {
      selectedOption: {
        name: ""
      },
      showMenu: false,
      placeholderText: "Please select an item"
    };
  },
  props: {
    options: {
      type: [Array, Object]
    },
    selected: {},
    placeholder: [String],
    mode: String,
    css: String,
    disabled: Boolean,
    title: { type: String, required: false },
  },
  computed: {
    hasTitle() {
      return this.title != undefined
    }
  },
  watch: {
    selected(newValue) {
      this.selectedOption = newValue
    }
  },
  mounted() {
    this.selectedOption = this.selected;

    if (this.placeholder) {
      this.placeholderText = this.placeholder;
    }
  },

  methods: {
    updateOption(option) {
      this.selectedOption = option;
      this.showMenu = false;
      this.$emit("updateOption", this.selectedOption);
    },

    toggleMenu() {
      this.showMenu = !this.showMenu;
    },

    modeType() {
      return this.mode == "form" ? "drop-form" : "";
    }
  }
};
</script>

<style>
.btn-group {
  position: relative;
}

.dropdown-toggle {
  padding: 0px;
  text-transform: none;
  margin-bottom: 7px;
  border: 0;
  float: none;
  box-shadow: none;
  border-radius: 3px;
}

.dropdown-toggle:after {
   font-family: FontAwesome;
    content: '\f078';
    padding-left: 0.5em;
      vertical-align: middle;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  float: left;
  width: 100%;
  padding: 5px 0;
  margin: 2px 0 0;
  list-style: none;
  text-align: left;
  background-color: #fff;
  border: 0px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;
}

.drop-form {
  border: solid 1px rgba(210, 215, 217, 0.1) !important;
  border-radius: 4px !important;
  padding: 12px !important;
  padding-bottom: 32px !important;
}

.dropdown-menu > li > a {
  padding: 10px 30px;
  display: block;
  clear: both;
  font-weight: normal;
  line-height: 1.6;
  color: #515365;
  white-space: nowrap;
  text-decoration: none;
}
.dropdown-menu > li > a:hover {
  background-color: inherit;
}

.dropdown-menu > li {
  overflow: hidden;
  width: 100%;
  position: relative;
  margin: 0;
}

.caret {
  display: relative;
  width: 0;
  position: relative;
  top: 16px;
  height: 0;
  margin-left: 7px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  float: right;
}

li {
  list-style: none;
}
</style>
